import { connect } from 'react-redux';
import { useState } from 'react';
import { Box, ListItemText, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';
import ConfidenceIndicator from '../ConfidenceIndicator';
import PointTypeSelector from '../selectors/PointTypeSelector';

const PointTypeEditor = ({
  open,
  column,
  actions,
  editing,
  setCurrentlyEditing,
  setCurrentEditor,
  pointTypes,
  loading,
}) => {
  const [selectedOption, setSelectedOption] = useState(pointTypes[editing[0].point_type_id]);

  if (!editing || editing.length <= 0) return null;

  return (
    <BaseFieldEditor
      open={open}
      onSave={() => {
        // This is a bit excessive for now until we wrangle staging transformations
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          point_type: {
            id: selectedOption.id,
            confidence: 100,
          },
        });
        action.doClose({ setCurrentlyEditing, setCurrentEditor });
      }}
      title="Point Type Editor"
      editing={editing}
      column={column}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
      loading={loading}
    >
      <PointTypeSelector
        value={selectedOption}
        setValue={setSelectedOption}
        sortOptions={(a, b) => {
          if (editing.length !== 1) return 0;
          const aConfidence = editing[0].data?.['auto_tagger.point_type_preds']?.[a.name] || 0;
          const bConfidence = editing[0].data?.['auto_tagger.point_type_preds']?.[b.name] || 0;
          if (aConfidence && !bConfidence) {
            return -1; // 'a' will be shown before 'b'
          }
          if (!aConfidence && bConfidence) {
            return 1; // 'b' will be shown before 'a'
          }
          return 0; // no sorting applied
        }}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <Box width="45px" height="35px">
              {editing.length === 1 &&
                editing[0].data?.['auto_tagger.point_type_preds']?.[option.name] && (
                  <ConfidenceIndicator
                    value={editing[0].data['auto_tagger.point_type_preds'][option.name] * 100}
                  />
                )}
            </Box>
            <ListItemText>{option.name}</ListItemText>
          </ListItem>
        )}
      />
    </BaseFieldEditor>
  );
};

export default connect(
  ({
    entities: {
      pointTypes: { byId: pointTypes },
    },
  }) => ({
    pointTypes,
  })
)(PointTypeEditor);
